import React, { Component } from 'react';
import Header from '../../components/header';
import Footer from '../../components/footer';
import request from 'request';


export default class AdminUsers extends Component {
  constructor (props) {
    super(props);

    this.state = {
      user_id: "-MX579OCmzdOBMEDKY2A", 
      token_id: "tok_620294243ede0fe78fb6532ec11c",
      customer_id: "",
      charge_id: "",
      submenu: "lists"
    };
  }

  componentWillMount () {
  }

  customer() {
    
    var payment_url = process.env.REACT_APP_FUNCTIONS_URL + "/payment"
    var options = {
      uri: payment_url,
      headers: {
        "Content-type": "application/json",
      },
      json: {
        "user_id": this.state.user_id,
        "token_id": this.state.token_id,
      }
    }

    //console.log(user.email)
    //console.log(options)

    request.post(options, function(error, response, body){
        console.log(body.message)
    });
  }

  payment() {
    
    var payment_url = process.env.REACT_APP_FUNCTIONS_URL + "/payment"
    var options = {
      uri: payment_url,
      headers: {
        "Content-type": "application/json",
      },
      json: {
        "user_id": this.state.user_id,
        "customer_id": this.state.customer_id,
        "amount": 2750

      }
    }

    //console.log(user.email)
    //console.log(options)

    request.post(options, function(error, response, body){
        console.log(body.message)
    });
  }

  capture() {
    
    var payment_url = process.env.REACT_APP_FUNCTIONS_URL + "/payment"
    var options = {
      uri: payment_url,
      headers: {
        "Content-type": "application/json",
      },
      json: {
        "user_id": this.state.user_id,
        "charge_id": this.state.charge_id,
        "capture": true
      }
    }

    //console.log(user.email)
    //console.log(options)

    request.post(options, function(error, response, body){
        console.log(body.message)
    });
  }

  refund() {
    
    var payment_url = process.env.REACT_APP_FUNCTIONS_URL + "/payment"
    var options = {
      uri: payment_url,
      headers: {
        "Content-type": "application/json",
      },
      json: {
        "user_id": this.state.user_id,
        "charge_id": this.state.charge_id,
        "refund": true
      }
    }

    //console.log(user.email)
    //console.log(options)

    request.post(options, function(error, response, body){
        console.log(body.message)
    });
  }

  changeSubMenu (menu_name) {
    this.setState({submenu: menu_name})
  }

  render () {

    return <div className="admin">
    <Header />
      <div className="admin-sub-menus">
        <ul>
          <li className={ this.state.submenu === "lists" ? "active" : "" } onClick={e => this.changeSubMenu("lists")}>管理者一覧</li>
          <li className={ this.state.submenu === "operation" ? "active" : "" } onClick={e => this.changeSubMenu("operation")}>オペレーション</li>
          <li className={ this.state.submenu === "setting" ? "active" : "" } onClick={e => this.changeSubMenu("setting")}>デバッグ</li>
        </ul>
      </div>
      <div className="admin-contents-wrapper">
        <div className={ this.state.submenu === "lists" ? "admin-user-lists active" : "admin-user-lists" }>
        </div>
        
        <div className={ this.state.submenu === "operation" ? "admin-user-operation active" : "admin-user-operation" }>
        </div>

        <div className={ this.state.submenu === "setting" ? "admin-user-setting active" : "admin-user-setting" }>
          <div className="sub-section">
            <div className="sub-section-title">顧客作成</div>
            <dl>
              <dt>ユーザーID</dt><dd><input type="text" value={this.state.user_id} onChange={e => this.setState({user_id: e.target.value})} /></dd>
              <dt>PayJPトークンID</dt><dd><input type="text" value={this.state.token_id} onChange={e => this.setState({token_id: e.target.value})} /></dd>
              <dt></dt><dd><input type="button" value={"顧客作成 トークンID:" + this.state.token_id} onClick={e => this.customer()} /></dd>
            </dl>
          </div>
          <div className="sub-section">
            <div className="sub-section-title">決済（オーソリ）</div>
            <dl>
              <dt>PayJP顧客ID</dt><dd><input type="text" value={this.state.customer_id} onChange={e => this.setState({customer_id: e.target.value})} /></dd>
              <dt></dt><dd><input type="button" value={"決済(オーソリ) 顧客ID:" + this.state.customer_id} onClick={e => this.payment()} /></dd>
            </dl>
          </div>
          <div className="sub-section">
            <div className="sub-section-title">決済（確定）または返金</div>
            <dl>
              <dt>PayJP決済ID</dt><dd><input type="text" value={this.state.charge_id} onChange={e => this.setState({charge_id: e.target.value})} /></dd>
              <dt></dt><dd><input type="button" value={"決済(確定) 決済ID:" + this.state.charge_id} onClick={e => this.capture()} /></dd>
              <dt></dt><dd><input type="button" value={"返金 決済ID:" + this.state.charge_id} onClick={e => this.refund()} /></dd>
            </dl>
          </div>
        </div>
      </div>
    <Footer />
    </div>;
  }
}